import { Link as RouterLink } from "react-router-dom";
import { Button, Stack, Typography } from "@mui/material";
import type { FacilityPromotionSummary } from "@bw/shared/types/generated";
import { OfferCard, OfferRow } from "../../../common/components/OfferCard";
import { SectionHeader } from "../../../common/components/SectionHeader";
import { withFacilityDiscoveryReturn } from "../../../common/facilityNavigation";

/** Public campaign terms as a compact swipe row; eligibility is checked at checkout. */
export function FacilityCampaignOffers({
  facilityId,
  promotions,
  facilitySearchReturn,
}: {
  facilityId: string;
  promotions: FacilityPromotionSummary[];
  facilitySearchReturn?: string;
}) {
  const destination = (service: FacilityPromotionSummary["service"]) =>
    withFacilityDiscoveryReturn(
      {
        court_reservation: `/book/${facilityId}`,
        open_play: `/dropin/${facilityId}`,
        classes: `/classes/${facilityId}`,
        coaching: `/facility/${facilityId}/coaches`,
      }[service],
      facilitySearchReturn,
    );
  const referrals = promotions.filter((promotion) => promotion.audience === "earned_referral");
  return (
    <Stack component="section" aria-labelledby="facility-offers-title" spacing={0.75}>
      <SectionHeader id="facility-offers-title" title="Offers" />
      <OfferRow>
        {promotions.map((promotion) => (
          <OfferCard
            key={promotion.promotion_id}
            promotion={promotion}
            to={destination(promotion.service)}
            subtitle={promotion.summary}
            detail
          />
        ))}
      </OfferRow>
      <Typography variant="caption" color="text.secondary" sx={{ px: 0.5 }}>
        Final eligibility and savings are confirmed before payment.
      </Typography>
      {referrals.map((promotion) => (
        <Button
          key={promotion.promotion_id}
          component={RouterLink}
          to={`/me/rewards?share=${encodeURIComponent(promotion.promotion_id)}`}
          size="small"
          sx={{ alignSelf: "flex-start" }}
        >
          Share &amp; earn: {promotion.headline}
        </Button>
      ))}
    </Stack>
  );
}
